<template>
  <div>
    <div class="container text-left">
      <h1 class="text-primary font-medium-1">
        Bestellung {{ SERVICE.name }}
      </h1>

      <b-progress :value="ORDER_STEPS_CURRENT" :max="ORDER_STEPS_TOTAL" class="mb-3 mt-3"></b-progress>

      <h2 class="h3">
        Schritt {{ ORDER_STEPS_CURRENT }} von {{ ORDER_STEPS_TOTAL }} - Bitte geben Sie die weiteren Informationen ein:
      </h2>

      <consulting-consent-section></consulting-consent-section>

      <comment-section></comment-section>
<!--      <b-card>-->
<!--        <b-form-group label="MA-ID - Eintrag nur durch Cable 4" label-for="ma-id">-->
<!--          <b-form-input-->
<!--              id="ma-id"-->
<!--              v-model="CHECKOUT_DATA.ma_id"-->
<!--              placeholder="MA-ID - Eintrag nur durch Cable 4"-->
<!--          />-->
<!--        </b-form-group>-->
<!--      </b-card>-->

      <b-card>
        <b-button variant="primary" @click="validateData()">nächster Schritt</b-button>
      </b-card>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import HardwareSection from "@/views/checkout/sections/HardwareSection";
import {
  BFormRadioGroup,
  BFormGroup,
  BFormInput, BCol, BRow, BFormDatepicker, BFormCheckbox
} from "bootstrap-vue";
import AdditionalOptionsSection from "@/views/checkout/sections/AdditionalOptionsSection";
import AppointmentSection from "@/views/checkout/sections/AppointmentSection";
import PhonelineSection from "@/views/checkout/sections/PhonelineSection";
import TVSection from "@/views/checkout/sections/TVSection";
import FTTHSection from "@/views/checkout/sections/FTTHSection";
import PayTVSection from "@/views/checkout/sections/PayTVSection";
import PhoneNumberSection from "@/views/checkout/sections/PhoneNumberSection";
import PhoneBookSection from "@/views/checkout/sections/PhoneBookSection";
import CommentSection from "@/views/checkout/sections/CommentSection";
import ConsultingConsentSection from "@/views/checkout/sections/ConsultingConsentSection";

export default {
  name: "CheckoutAdditionalInformations",
  components: {
    AdditionalOptionsSection,
    HardwareSection,
    PayTVSection,
    CommentSection,
    ConsultingConsentSection,
    BFormRadioGroup,
    BFormGroup,
    BFormDatepicker,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
  },
  data() {
    return {
      address: {},
      value: [],
      showInfoBlock: process.env.VUE_APP_ROOT_SHOW_CABLE_4_INFO_BLOCKS
    }
  },
  beforeMount() {
    this.$store.commit('SET_ORDER_STEPS_CURRENT', 4)

    if (!this.SERVICE || !this.CHECKOUT_DATA) {
      this.$router.push({name: 'Availability'})
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA', 'ORDER_STEPS_CURRENT', 'ORDER_STEPS_TOTAL']),
    state() {
      return Boolean(this.CHECKOUT_DATA.salutation)
    },
  },
  methods: {
    validateData() {
      this.$router.push({name: 'Checkout Overview'})
    },
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
  }

}
</script>

<style lang="scss">
.inner-section {
  padding-left: 1.8rem;
}
</style>
